module.exports = __webpack_public_path__ + "img/06.2dc85488.jpg";